import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Separator } from "@radix-ui/react-separator";
import Rating from "./rating";
import { typographyClass } from "./typography";
import { convertTextToTextWithBr } from "@/lib/ui-utils";

export type ReviewProps = {
  website: string;
  author: string;
  text: string;
  score: number;
};

export default function ReviewCard(props: ReviewProps) {
  return (
    <Card className="select-none h-full bg-tertiary text-tertiary-foreground border-0">
      <CardHeader>
        <CardTitle className={typographyClass.smallSubtitle}>
          {props.author}
        </CardTitle>
        <CardDescription className="text-tertiary-foreground/50">
          {props.website}
        </CardDescription>
        <Rating score={props.score} />
        <Separator className="!mt-6 bg-muted w-full h-[1px]" />
      </CardHeader>
      <CardContent>{convertTextToTextWithBr(props.text)}</CardContent>
    </Card>
  );
}
